module.exports = ['$scope', 'User', '$utils', 'secondAuthService', '$timeout', '$translate', '$ionicPopup',
  function ($scope, User, $utils, secondAuthService, $timeout, $translate, $ionicPopup) {
    init()

    function init() {
      if ($scope.needVerifyCode) {
        $scope.loginParams.verifyCode = ''
        $scope.user && $scope.changeVerifyCode()
      }
      if (!$scope.loginParams) $scope.loginParams = {}
      if ($scope.authModalContent == 'authByPhone.html') {
        if (!$scope.remainingSeconds) {
          sendVerifyCell()
        } else {
          $scope.isSendCodeDisabled = true
          sendCodeCountDown()
        }
      }
      if ($scope.authModalContent == 'authByApp.html') {
        const failReason = $scope.loginFailedReason ? $scope.loginFailedReason.data : {}
        const user = $scope.user || User.getCurrentUser()
        const options = {
          tempSid: failReason['var'].sid,
          trans: 'login'
        }
        secondAuthService.triggerSecondAuth(user, options).then(function (data) {
          console.log(data)
          if ($scope.polling) {
            $timeout.cancel($scope.polling)
          }
          pollingforAuth(failReason['var'].sid, 'login', 0)
        }, function (error) {
          $utils.$notify.set({message: $translate.instant('VERIFICATION.TRIGGER_FAILED_INPUT_CODE')})
          console.log(JSON.stringify(error))
        })
      }
    }

    function pollingforAuth(tempSid, trans, count) {
      if (count >= 300) {
        $utils.$notify.set({message: $translate.instant('VERIFICATION.AUTH_TIMEOUT')})
        return
      }
      count += 1
      const user = $scope.user || User.getCurrentUser()
      $scope.polling = $timeout(function () {
        secondAuthService.querySecondAuthValidateStage(user, tempSid, trans).then(function (data) {
          if (data['var'].stage == 'VALIDATED') {
            // 验证完成,使用该Sid进行登录
            $scope.loginParams.tempSid = tempSid
            console.log('tempSid is ---------' + tempSid)
            if ($scope.needVerifyCode) {
              $scope.loginParams.dynamicPwd = ''
              $scope.isAuthSuccess = true
              $scope.submit()
            } else {
              typeof $scope.closeModal === 'function' && $scope.closeModal()
              $scope.submit()
            }
          } else {
            pollingforAuth(tempSid, trans, count)
          }
        }, function (error) {
          console.log(JSON.stringify(error))
        })
      }, 1000)
    }

    $scope.toggleInputCode = function () {
      $scope.inputSecAuthCode = !$scope.inputSecAuthCode
    }

    function sendVerifyCell() {
      const user = $scope.user || User.getCurrentUser()
      secondAuthService.authSendValidCode(user, $scope.loginParams.uid, $scope.loginParams.password).then(function (data) {
        // 返回的sid用于短信验证码登录
        $scope.loginParams.tempSid = data['var'].sid
        const user = $scope.user || User.getCurrentUser()
        secondAuthService.querySecondAuth(user, user.config.email).then(function (data) {
          // if (data['var']) {
          //   $scope.$emit('VERIFICATION.SET_SEND_CODE_CACHE', {cellNumber: {number: data['var'].cellNumber}})
          // } else {
          //   const cellNumber = localStorage.getItem('cellNumber')
          //   cellNumber && $scope.$emit('VERIFICATION.SET_SEND_CODE_CACHE', {cellNumber: {number: cellNumber}})
          // }
          const cellNumber = localStorage.getItem('cellNumber')
          if (cellNumber) {
            const last4Number = cellNumber.slice(-4)
            cellNumber && $scope.$emit('VERIFICATION.SET_SEND_CODE_CACHE', {cellNumber: {number: last4Number}})
          }
          $scope.remainingSeconds = 60
          $scope.isSendCodeDisabled = true
          $utils.$notify.set({message: $translate.instant('VERIFICATION.MSG_HAS_SENT_PHONE')})
          sendCodeCountDown()
          console.log(data)
        }, function (error) {
          console.log(JSON.stringify(error))
        })
      }, function (error) {
        if (error.code === 'FA_TOO_FREQUENTLY') {
          $utils.$notify.set({message: $translate.instant('VERIFICATION.MSG_SEND_FREQUENTLY')})
        } else {
          $utils.$notify.set({message: $translate.instant('VERIFICATION.MSG_SEND_FAILED')})
        }
        console.log(JSON.stringify(error))
      })
    }

    function sendCodeCountDown() {
      $scope.remainingSeconds--
      if ($scope.remainingSeconds <= 0) {
        $scope.isSendCodeDisabled = false
      } else {
        $scope.sendCodeCountDownPromise = $timeout(sendCodeCountDown, 1000)
      }
    }

    $scope.resetInputFieldStyle = function() {
      $scope.isInvalidCode = false
    }

    $scope.sendVerifyCell = sendVerifyCell

    $scope.submit = function () {
      const isAuthLogin = $scope.authModalContent == 'authByApp.html' || $scope.authModalContent == 'authByPhone.html'
      if (typeof $scope.login === 'function') {
        $scope.login(isAuthLogin)
      } else {
        console.log('$scope.login is not function!')
      }
    }

    $scope.goBack = function () {
      if ($scope.polling) {
        $timeout.cancel($scope.polling)
      }
      if (typeof $scope.closeModal === 'function') {
        $scope.closeModal()
        return
      }
      $scope.secondAuthModal && $scope.secondAuthModal.remove()
    }

    $scope.$watch(function () {
      return !!$scope.secondAuthModal
    }, function (value) {
      console.log(value)
      if (!value && $scope.polling) {
        $timeout.cancel($scope.polling)
      }
    })

    $scope.$on('VERIFICATION.WRONG_CODE', function() {
      $scope.isInvalidCode = true
    })

    $scope.$on('$destroy', function() {
      $scope.$emit('VERIFICATION.SET_SEND_CODE_CACHE', {remainingSeconds: $scope.remainingSeconds})
      $timeout.cancel($scope.sendCodeCountDownPromise)
    })
  }]



// WEBPACK FOOTER //
// ./src/js/controllers/secAuthLoginCtrl.js